<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div>
            <div style="overflow:auto">
                <div class="ZAfont_family ZAfont_size" style="margin-bottom:30px">
                    <div v-if="motorData!=null">
                        <div v-if="motorData!=null">
                            <span class="my_color_00338e my_font-weight_600">{{$t('1089')}}:</span>
                            <span> {{motorData}}</span>
                            <span v-if="motorAxleLoad!=null">
                                <span> | </span>
                                <span>{{$t('1326')}}: </span>
                                <span>{{motorAxleLoad}}</span>
                            </span>
                        </div>
                        <div v-if="tractionSheaveData!=null">
                            <span class="my_color_00338e my_font-weight_600">{{$t('1301')}}:</span>
                            <span style="margin-left:5px">
                                <span>{{tractionSheaveData}}</span>
                            </span>
                        </div>
                        <hr />
                    </div>
                    <div v-if="motorSelection!=undefined&&motorSelection!=null">
                        <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('1098')}} | {{$t('1301')}}</div>
                        <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px;">
                            <div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('1089')}}:</div>
                                    </div>
                                    <div v-if="motorSelection.length==0 || motorSelection.length>4">
                                        <select v-model="selectedMotorElement" class="my_select" style="width:100%">
                                            <option value="null" hidden>{{$t('3174')}}</option>
                                            <option value="" hidden>{{$t('3174')}}</option>
                                            <option v-for="motor in motorSelection" v-bind:value="motor">
                                                {{motor.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="motorSelection.length>0 && motorSelection.length<=4">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="motor in motorSelection">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_motor(motor)" v-bind:checked="motor.selected" />
                                                    <label for="motor" style="margin-left:10px">
                                                        {{motor.text}}
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div> </div>
                        </div>
                        <div v-if="selectedMotorElement!=null&&tractionSheaveDiameterSelection!=null&&tractionSheaveDiameterSelection.length>0">
                            <div style="margin-bottom: 30px;display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px;">
                                <div>
                                    <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                        <div>
                                            <div class="ZAfont_family ZAfont_size">{{$t('1028')}}:</div>
                                        </div>
                                        <div v-if="tractionSheaveDiameterSelection.length==0 || tractionSheaveDiameterSelection.length>4">
                                            <select v-model="selectedTractionSheaveDiameterElement" class="my_select" style="width:100%">
                                                <option value="null" hidden>{{$t('3174')}}</option>
                                                <option value="" hidden>{{$t('3174')}}</option>
                                                <option v-for="tractionSheaveDiameter in tractionSheaveDiameterSelection" v-bind:value="tractionSheaveDiameter">
                                                    {{tractionSheaveDiameter.tsd}}
                                                </option>
                                            </select>
                                        </div>
                                        <div v-if="tractionSheaveDiameterSelection.length>0 && tractionSheaveDiameterSelection.length<=4">
                                            <div style="display: grid;">
                                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                    <li v-for="tractionSheaveDiameter in tractionSheaveDiameterSelection">
                                                        <input type="checkbox" @input="change_Selected_atElementOf_tractionSheaveDiameter(tractionSheaveDiameter)" v-bind:checked="tractionSheaveDiameter.selected" />
                                                        <label for="tractionSheaveDiameter" style="margin-left:10px">
                                                            {{tractionSheaveDiameter.tsd}}
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div> </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
                <div style="margin-top:30px">
                    <div v-if="frameMountingSelection!=undefined&&frameMountingSelection!=null">
                        <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3618')}}</div>
                        <div style="margin-bottom: 30px;display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px;">
                            <div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('407')}}:</div>
                                    </div>
                                    <div v-if="frameMountingSelection.length==0 || frameMountingSelection.length>4">
                                        <select v-model="selectedFrameMounting" class="my_select" style="width:100%">
                                            <option value="null" hidden>{{$t('3174')}}</option>
                                            <option value="" hidden>{{$t('3174')}}</option>
                                            <option v-for="frameMounting in frameMountingSelection" v-bind:value="frameMounting">
                                                {{frameMounting.blockNumber}}
                                                {{frameMounting.farbe.text!=null?frameMounting.farbe.useTextKey? ' | ' + $t(frameMounting.farbe.textKey): ' | ' + frameMounting.farbe.textUI:''}}
                                                {{frameMounting.fratyp.text!=null?frameMounting.fratyp.useTextKey? ' | ' + $t(frameMounting.fratyp.textKey): ' | ' + frameMounting.fratyp.textUI:''}}
                                                {{frameMounting.bezei.text!=null?frameMounting.bezei.useTextKey? ' | ' + $t(frameMounting.bezei.textKey): ' | ' + frameMounting.bezei.textUI:''}}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="frameMountingSelection.length>0 && frameMountingSelection.length<=4">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox2 ZAfont_family ZAfont_size">
                                                <li v-for="frameMounting in frameMountingSelection">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_frameMounting(frameMounting)" v-bind:checked="frameMounting.selected" />
                                                    <label for="frameMounting" style="margin-left:10px">
                                                        {{frameMounting.blockNumber}}
                                                        {{frameMounting.farbe.text!=null?frameMounting.farbe.useTextKey? ' | ' + $t(frameMounting.farbe.textKey): ' | ' + frameMounting.farbe.textUI:''}}
                                                        {{frameMounting.fratyp.text!=null?frameMounting.fratyp.useTextKey? ' | ' + $t(frameMounting.fratyp.textKey): ' | ' + frameMounting.fratyp.textUI:''}}
                                                        {{frameMounting.bezei.text!=null?frameMounting.bezei.useTextKey? ' | ' + $t(frameMounting.bezei.textKey): ' | ' + frameMounting.bezei.textUI:''}}
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div> </div>
                        </div>
                        <hr />
                    </div>
                    <div v-if="fraartSelection!=null&&fraartSelection.length>0">
                        <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3255')}}</div>
                        <div style="margin-bottom: 30px;display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px;">
                            <div>
                                <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('3008')}}:</div>
                                    </div>
                                    <div v-if="fraartSelection.length==0 || fraartSelection.length>4">
                                        <select v-model="selectedFraart" class="my_select" style="width:100%">
                                            <option value="null" hidden>{{$t('3174')}}</option>
                                            <option value="" hidden>{{$t('3174')}}</option>
                                            <option v-for="fraart in fraartSelection" v-bind:value="fraart">
                                                {{fraart.text.useTextKey?$t(fraart.text.textKey):fraart.text.textUI}}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="fraartSelection.length>0 && fraartSelection.length<=4">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="fraart in fraartSelection">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_fraart(fraart)" v-bind:checked="fraart.selected" v-bind:disabled="fraart.selected" />
                                                    <span style="margin-left:10px">{{fraart.text.useTextKey?$t(fraart.text.textKey):fraart.text.textUI}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="fratypSelection!=null&&fratypSelection.length>0" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('407')}}:</div>
                                    </div>
                                    <div v-if="fratypSelection.length==0 || fratypSelection.length>4">
                                        <select v-model="selectedFratyp" class="my_select" style="width:100%">
                                            <option value="null" hidden>{{$t('3174')}}</option>
                                            <option value="" hidden>{{$t('3174')}}</option>
                                            <option v-for="fratyp in fratypSelection" v-bind:value="fratyp">
                                                {{fratyp.text.useTextKey?$t(fratyp.text.textKey):fratyp.text.textUI}}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="fratypSelection.length>0 && fratypSelection.length<=4">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="fratyp in fratypSelection">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_fratyp(fratyp)" v-bind:checked="fratyp.selected" v-bind:disabled="fratyp.selected" />
                                                    <span style="margin-left:10px">{{fratyp.text.useTextKey?$t(fratyp.text.textKey):fratyp.text.textUI}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="motorData!=null&&pulleyAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div> </div>
                                    <div>
                                        <button @click="frameCalculationModalShown=true" class="btn my_btn_standard_blue" style="width:100%">{{$t('3296')}}</button>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('1142')}}:</div>
                                    </div>
                                    <div v-if="urdSelection.length==0 || urdSelection.length>4">
                                        <select v-model="selectedUrd" class="my_select" style="width:100%">
                                            <option value="null" hidden>{{$t('3174')}}</option>
                                            <option value="" hidden>{{$t('3174')}}</option>
                                            <option v-for="urd in urdSelection" v-bind:value="urd">
                                                {{urd.value}}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="urdSelection.length>0 && urdSelection.length<=4">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-for="urd in urdSelection">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_urd(urd)" v-bind:checked="urd.selected" v-bind:disabled="urd.selected" />
                                                    <span style="margin-left: 10px">{{urd.value}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true&&positionInformation!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('3383')}}:</div>
                                    </div>
                                    <div class="ZAfont_family ZAfont_size">
                                        <div style="display: grid;">
                                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                                <li v-if="positionInformation.universalAvailable==true">
                                                    <input v-if="positionInformation.leftAvailable==true||positionInformation.rightAvailable==true" type="checkbox" @input="change_Selected_atElementOf_position('universal')" v-bind:checked="positionUniversal==1" v-bind:disabled="positionUniversal==1" />
                                                    <span style="margin-left:10px">{{$t('3622')}}</span>
                                                </li>
                                                <li v-if="positionInformation.leftAvailable==true">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_position('left')" v-bind:checked="positionLeft==1" v-bind:disabled="positionLeft==1" />
                                                    <span style="margin-left:10px">{{$t('271')}}</span>
                                                </li>
                                                <li v-if="positionInformation.rightAvailable==true">
                                                    <input type="checkbox" @input="change_Selected_atElementOf_position('right')" v-bind:checked="positionRight==1" v-bind:disabled="positionRight==1" />
                                                    <span style="margin-left:10px">{{$t('270')}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true && frameDetails!=null && frameDetails.aslmx!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('1027')}}:</div>
                                    </div>
                                    <div class="ZAfont_family ZAfont_size">
                                        <span v-if="frameDetails.aslmn!=null">{{frameDetails.aslmn}} mm - </span>
                                        <span>{{frameDetails.aslmx}} mm</span>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true && frameDetails!=null && frameDetails.avum!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('1026')}}:</div>
                                    </div>
                                    <div class="ZAfont_family ZAfont_size">
                                        <span>{{frameDetails.avum}} mm</span>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true && frameDetails!=null && frameDetails.alast!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('1326')}}:</div>
                                    </div>
                                    <div class="ZAfont_family ZAfont_size">
                                        <div>{{frameDetails.alast}} kg</div>
                                        <div v-if="motorAxleLoad!=null&&motorAxleLoad>frameDetails.alast" style="color:red">{{$t('3706')}}</div>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true && frameDetails!=null && frameDetails.mblatt!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">{{$t('1193')}}:</div>
                                    </div>
                                    <div class="ZAfont_family ZAfont_size">
                                        <span>{{frameDetails.mblatt}}</span>
                                    </div>
                                </div>
                                <div v-if="pulleyAvailable==true && frameDetails!=null && frameDetails.mblatt!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                    <div>
                                        <div class="ZAfont_family ZAfont_size">ID:</div>
                                    </div>
                                    <div class="ZAfont_family ZAfont_size">
                                        <span>{{frameDetails.frameId}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedFratyp!=null&&selectedFratyp.imagePath!=null&&selectedFratyp.imagePath!=''" style="display:flex; justify-content: center; align-items: center">
                                <div>
                                    <Images :imageFilePath="selectedFratyp.imagePath" :maxImageHeight="250" :maxImageWidth="250"></Images>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
                <div v-if="pulleyAvailable==true" style="margin-top: 30px">
                    <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('1062')}}</div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('1062')}} ({{$t('3395')}}):</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <div v-if="urzSelection!=null&&urzSelection.length>0" style="display: grid;">
                                <input type="checkbox" v-model="lur" v-bind:disabled="urzSelection==null||urzSelection.length==0" />
                            </div>
                            <div v-if="urzSelection==null||urzSelection.length==0">{{$t('3702')}}</div>
                        </div>
                    </div>
                    <div v-if="lur==true && pulleyDetails!=null && pulleyDetails.urd!=null" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3038')}} | {{$t('90')}}:</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <span>{{pulleyDetails.urd}} mm</span>
                            <span v-if="pulleyDetails.urb!=null"> | {{pulleyDetails.urb}} mm</span>
                        </div>
                    </div>
                    <div v-if="lur==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('165')}}:</div>
                        </div>
                        <div v-if="urzSelection.length==0 || urzSelection.length>4">
                            <select v-model="selectedUrz" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="urz in urzSelection" v-bind:value="urz">
                                    {{urz.value}}
                                </option>
                            </select>
                        </div>
                        <div v-if="urzSelection.length>0 && urzSelection.length<=4">
                            <div style="display: grid;">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size" v-bind:class="{my_inputCheckboxSelected:urzSelection.length==1}">
                                    <li v-for="urz in urzSelection">
                                        <span v-if="urzSelection.length>1||urz.selected==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_urz(urz)" v-bind:checked="urz.selected" v-bind:disabled="urz.selected" />
                                            <span style="margin-left:10px">{{urz.value}}</span>
                                        </span>
                                        <span v-if="urzSelection.length==1&&urz.selected==true">{{urz.value}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="lur==true && pulleyDetails!=null && pulleyDetails.urd!=null" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('1294')}}:</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <span>{{pulleyDetails.urra}} mm</span>
                        </div>
                    </div>
                    <div v-if="lur==true && pulleyDetails!=null && pulleyDetails.ursdmx!=null" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('1067')}}:</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <span v-if="pulleyDetails.ursdmn!=null && pulleyDetails.ursdmn!=pulleyDetails.ursdmx">{{pulleyDetails.ursdmn}} mm - </span>
                            <span>{{pulleyDetails.ursdmx}} mm</span>
                        </div>
                    </div>
                    <div v-if="lur==true && pulleyDetails!=null && pulleyDetails.urfmax!=null" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3421')}}:</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <span>{{pulleyDetails.urfmax}} kg</span>
                        </div>
                    </div>
                    <div v-if="lur==true && pulleyDetails!=null && pulleyDetails.urtyp!=null && pulleyDetails.urtyp.text!=null" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('407')}}:</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <span>{{pulleyDetails.urtyp.useTextKey?$t(pulleyDetails.urtyp.textKey):pulleyDetails.urtyp.textUI}}</span>
                        </div>
                    </div>
                    <div v-if="lur==true && pulleyDetails!=null && pulleyDetails.pulleyId!=null" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">ID:</div>
                        </div>
                        <div class="ZAfont_family ZAfont_size">
                            <span>{{pulleyDetails.pulleyId}}</span>
                        </div>
                    </div>
                    <hr />
                </div>
                <div v-if="selectedFraart!=null&&(optionRetrofitAvailable==true||optionEmergencyStopAvailable==true||optionRopeGuardAvailable==true||optionIsolationAvailable==true||balAvailable==true||mkAvailable==true)" style="margin-top: 30px">
                    <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('1016')}}</div>
                    <div>
                        <div v-if="optionRetrofitAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3386')}}:</div>
                            </div>
                            <div class="ZAfont_family ZAfont_size">
                                <div style="display: grid;">
                                    <input type="checkbox" v-model="optionRetrofit" />
                                </div>
                            </div>
                        </div>
                        <div v-if="optionEmergencyStopAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3387')}}:</div>
                            </div>
                            <div class="ZAfont_family ZAfont_size">
                                <div style="display: grid;">
                                    <input type="checkbox" v-model="optionEmergencyStop" />
                                </div>
                            </div>
                        </div>
                        <div v-if="optionRopeGuardAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3533')}} ({{$t('3388')}}):</div>
                            </div>
                            <div class="ZAfont_family ZAfont_size">
                                <div style="display: grid;">
                                    <input type="checkbox" v-model="optionRopeGuard" />
                                </div>
                            </div>
                        </div>
                        <div v-if="optionIsolationAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3389')}}:</div>
                            </div>
                            <div class="ZAfont_family ZAfont_size">
                                <div style="display: grid;">
                                    <input type="checkbox" v-model="optionIsolation" />
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3391')}}:</div>
                            </div>
                            <div v-if="balAvailable==true && balSelection.length>4">
                                <select v-model="selectedBal" class="my_select" style="width:100%">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="bal in balSelection" v-bind:value="bal">
                                        {{bal.text.useTextKey?$t(bal.text.textKey):bal.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="balAvailable==true && balSelection.length>0 && balSelection.length<=4">
                                <div style="display: grid;">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="bal in balSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_bal(bal)" v-bind:checked="bal.selected" v-bind:disabled="bal.selected" />
                                            <span style="margin-left:10px">{{bal.text.useTextKey?$t(bal.text.textKey):bal.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="balAvailable==false||balSelection.length==0">{{$t('3703')}}</div>
                        </div>
                        <div v-if="mkAvailable==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3396')}}:</div>
                            </div>
                            <div v-if="mkSelection.length==0 || mkSelection.length>4">
                                <select v-model="selectedMk" class="my_select" style="width:100%">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="mk in mkSelection" v-bind:value="mk">
                                        {{mk.text.useTextKey?$t(mk.text.textKey):mk.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="mkSelection.length>0 && mkSelection.length<=4">
                                <div style="display: grid;">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="mk in mkSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_mk(mk)" v-bind:checked="mk.selected" v-bind:disabled="mk.selected" />
                                            <span style="margin-left:10px">{{mk.text.useTextKey?$t(mk.text.textKey):mk.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </div>
        <div class="my_btn_nextConfigurationStep_position">
            <button @click="furtherToManualHome_Cancel()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3366')}}</button>
            <button @click="deleteFrame()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3721')}}</button>
            <button @click="furtherToManualHome()" class="btn my_btn_nextConfigurationStep">{{$t('1023')}}</button>
        </div>

        <FrameModal v-if="frameCalculationModalShown" @close="closeFrameCalculationModalShown" :propElevatorMotor_Machine_Selection_Shown=true :manual=true :motorData="motorData" :motorTextKey="1089" :tractionSheaveData="tractionSheaveData" :tractionSheaveTextKey="1301"></FrameModal>
    </div>
</template>


<script>
    import router from '../../../router';
    import LoaderIcon from '../../loader/LoaderIcon';
    import InvalidInputs from '../../configuration/InvalidInputs'
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import Images from '../../configuration/Images';
    import FrameModal from '../../configuration/FrameModal';
    import { frameManual } from '../../../store/frameManual.module';

    export default {
        name: 'FrameManual',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
            FrameModal,
        },
        data() {
            return {
                frameCalculation_Modal_Shown: false,
            }
        },

        created() {
            if (this.$store.state.manualHome.kid == null) {
                router.push('../manualStep/ManualHome');
            }
            this.$store.commit('configurations/MANU_configuration', true);
            this.$store.dispatch('frameManual/get_motorInformation_storeAction');
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            motorData: {
                get() {
                    return this.$store.state.frameManual.motorData;
                }
            },
            tractionSheaveData: {
                get() {
                    return this.$store.state.frameManual.tractionSheaveData;
                }
            },
            motorAxleLoad: {
                get() {
                    return this.$store.state.frameManual.motorAxleLoad;
                }
            },
            motorSelection: {
                get() {
                    if (this.$store.state.frameManual.motorSelection != undefined && this.$store.state.frameManual.motorSelection != null && Array.isArray(this.$store.state.frameManual.motorSelection) && this.$store.state.frameManual.motorSelection.length > 0)
                        return this.$store.state.frameManual.motorSelection;
                    return null;
                }
            },
            selectedMotorElement: {
                get() {
                    return this.$store.state.frameManual.selectedMotorElement;
                },
                set(value) {
                    this.change_Selected_atElementOf_motor(value);
                }
            },
            tractionSheaveDiameterSelection: {
                get() {
                    if (this.selectedMotorElement != null && this.selectedMotorElement.text != null && this.$store.state.frameManual.tractionSheaveDiameterSelection != undefined && this.$store.state.frameManual.tractionSheaveDiameterSelection != null && Array.isArray(this.$store.state.frameManual.tractionSheaveDiameterSelection) && this.$store.state.frameManual.tractionSheaveDiameterSelection.length > 0)
                        return this.$store.state.frameManual.tractionSheaveDiameterSelection.filter(i => i.text == this.selectedMotorElement.text);
                    return null;
                }
            },
            selectedTractionSheaveDiameterElement: {
                get() {
                    return this.$store.state.frameManual.selectedTractionSheaveDiameterElement;
                },
                set(value) {
                    this.change_Selected_atElementOf_tractionSheaveDiameter(value);
                }
            },
            frameCalculationModalShown: {
                get() {
                    return this.frameCalculation_Modal_Shown;
                },
                set(value) {
                    if (value == true) {
                        this.$store.dispatch('frameModal/get_frame_Informations_Manual_storeAction');
                    }
                    this.frameCalculation_Modal_Shown = value;
                }
            },

            frameMountingSelection: {
                get() {
                    if (this.$store.state.frameManual.frameMountingSelection != undefined && this.$store.state.frameManual.frameMountingSelection != null && Array.isArray(this.$store.state.frameManual.frameMountingSelection) && this.$store.state.frameManual.frameMountingSelection.length > 0)
                        return this.$store.state.frameManual.frameMountingSelection;
                    return null;
                }
            },
            selectedFrameMounting: {
                get() {
                    return this.$store.state.frameManual.selectedFrameMounting;
                },
                set(value) {
                    this.change_Selected_atElementOf_frameMounting(value);
                }
            },

            fraartSelection: {
                get() {
                    return this.$store.state.frameManual.fraartSelection;
                },
            },
            selectedFraart: {
                get() {
                    return this.$store.state.frameManual.selectedFraart;
                },
                set(value) {
                    this.change_Selected_atElementOf_fraart(value);
                }
            },
            fratypSelection: {
                get() {
                    return this.$store.state.frameManual.fratypSelection;
                },
            },
            selectedFratyp: {
                get() {
                    return this.$store.state.frameManual.selectedFratyp;
                },
                set(value) {
                    this.change_Selected_atElementOf_fratyp(value);
                }
            },

            pulleyAvailable: {
                get() {
                    if (this.selectedFratyp != null && this.selectedFratyp.hasOwnProperty('pulleyAvailable')) {
                        return this.selectedFratyp.pulleyAvailable;
                    }
                    return false;
                }
            },
            urdSelection: {
                get() {
                    return this.$store.state.frameManual.urdSelection;
                },
            },
            selectedUrd: {
                get() {
                    return this.$store.state.frameManual.selectedUrd;
                },
                set(value) {
                    this.change_Selected_atElementOf_urd(value);
                }
            },
            positionInformation: {
                get() {
                    return this.$store.state.frameManual.positionInformation;
                },
            },
            positionUniversal: {
                get() {
                    return this.$store.state.frameManual.positionUniversal;
                },
                set(value) {
                    this.change_Selected_atElementOf_position(value);
                }
            },
            positionLeft: {
                get() {
                    return this.$store.state.frameManual.positionLeft;
                },
                set(value) {
                    this.change_Selected_atElementOf_position(value);
                }
            },
            positionRight: {
                get() {
                    return this.$store.state.frameManual.positionRight;
                },
                set(value) {
                    this.change_Selected_atElementOf_position(value);
                }
            },
            frameDetails: {
                get() {
                    return this.$store.state.frameManual.frameDetails;
                },
            },
            urzSelection: {
                get() {
                    return this.$store.state.frameManual.urzSelection;
                },
            },
            selectedUrz: {
                get() {
                    return this.$store.state.frameManual.selectedUrz;
                },
                set(value) {
                    this.change_Selected_atElementOf_urz(value);
                }
            },
            pulleyDetails: {
                get() {
                    return this.$store.state.frameManual.pulleyDetails;
                },
            },
            lur: {
                get() {
                    return this.$store.state.frameManual.lur;
                },
                set(value) {
                    this.$store.dispatch('frameManual/change_lur_storeAction', value);
                }
            },
            optionRetrofit: {
                get() {
                    return this.$store.state.frameManual.optionRetrofit;
                },
                set(value) {
                    this.$store.dispatch('frameManual/change_optionRetrofit_storeAction', value);
                }
            },
            optionEmergencyStop: {
                get() {
                    return this.$store.state.frameManual.optionEmergencyStop;
                },
                set(value) {
                    this.$store.dispatch('frameManual/change_optionEmergencyStop_storeAction', value);
                }
            },
            optionRopeGuard: {
                get() {
                    return this.$store.state.frameManual.optionRopeGuard;
                },
                set(value) {
                    this.$store.dispatch('frameManual/change_optionRopeGuard_storeAction', value);
                }
            },
            optionIsolation: {
                get() {
                    return this.$store.state.frameManual.optionIsolation;
                },
                set(value) {
                    this.$store.dispatch('frameManual/change_optionIsolation_storeAction', value);
                }
            },
            balSelection: {
                get() {
                    return this.$store.state.frameManual.balSelection;
                },
            },
            selectedBal: {
                get() {
                    return this.$store.state.frameManual.selectedBal;
                },
                set(value) {
                    this.change_Selected_atElementOf_bal(value);
                }
            },
            mkSelection: {
                get() {
                    return this.$store.state.frameManual.mkSelection;
                },
            },
            selectedMk: {
                get() {
                    return this.$store.state.frameManual.selectedMk;
                },
                set(value) {
                    this.change_Selected_atElementOf_mk(value);
                }
            },
            optionRetrofitAvailable: {
                get() {
                    return this.$store.state.frameManual.optionRetrofitAvailable;
                },
            },
            optionEmergencyStopAvailable: {
                get() {
                    return this.$store.state.frameManual.optionEmergencyStopAvailable;
                },
            },
            optionRopeGuardAvailable: {
                get() {
                    return this.$store.state.frameManual.optionRopeGuardAvailable;
                },
            },
            optionIsolationAvailable: {
                get() {
                    return this.$store.state.frameManual.optionIsolationAvailable;
                },
            },
            balAvailable: {
                get() {
                    return this.$store.state.frameManual.balAvailable;
                },
            },
            mkAvailable: {
                get() {
                    return this.$store.state.frameManual.mkAvailable;
                },
            },


        },

        methods: {
            change_Selected_atElementOf_motor(value) {
                this.$store.dispatch('frameManual/change_Selected_motor_storeAction', value);
            },
            change_Selected_atElementOf_tractionSheaveDiameter(value) {
                this.$store.dispatch('frameManual/change_Selected_tractionSheaveDiameter_storeAction', value);
            },
            changed_frameWrappingAngle() {
                this.$store.dispatch('frameManual/get_allFrameDetails_storeAction');
                this.frameCalculationModalShown = false;
            },
            closeFrameCalculationModalShown() {
                this.frameCalculationModalShown = false;
            },
            change_Selected_at_frame_Selection(value) {
                this.$store.dispatch('frameModal/checkIf_changesAt_frame_changes_configurationFlow_storeAction', value);
            },
            change_Selected_atElementOf_frameMounting(value) {
                this.$store.dispatch('frameManual/change_Selected_frameMounting_storeAction', value);
                if (this.selectedFraart != null) {
                    this.$store.dispatch('frameManual/change_Selected_fraart_storeAction', null);
                }
            },
            change_Selected_atElementOf_fraart(value) {
                this.$store.dispatch('frameManual/change_Selected_fraart_storeAction', value);
                if (this.selectedFrameMounting != null) {
                    this.$store.dispatch('frameManual/change_Selected_frameMounting_storeAction', null);
                }
            },
            change_Selected_atElementOf_fratyp(value) {
                this.$store.dispatch('frameManual/change_Selected_fratyp_storeAction', value);
            },
            change_Selected_atElementOf_urd(value) {
                this.$store.dispatch('frameManual/change_Selected_urd_storeAction', value);
            },
            change_Selected_atElementOf_position(value) {
                this.$store.dispatch('frameManual/change_Selected_position_storeAction', value);
            },
            change_Selected_atElementOf_urz(value) {
                this.$store.dispatch('frameManual/change_Selected_urz_storeAction', value);
            },
            change_Selected_atElementOf_bal(value) {
                this.$store.dispatch('frameManual/change_Selected_bal_storeAction', value);
            },
            change_Selected_atElementOf_mk(value) {
                this.$store.dispatch('frameManual/change_Selected_mk_storeAction', value);
            },
            furtherToManualHome() {
                this.$store.dispatch('frameManual/checkIf_frameManual_areValid_storeAction');
            },
            furtherToSupplies() {
                router.push({ params: { slug: 'suppliesMotorManual' } })
            },
            furtherToManualHome_Cancel() {
                this.$store.dispatch('inputsManual/cancelManualMotorConfiguration_storeAction')
            },
            deleteFrame() {
                this.$store.dispatch('frameManual/set_withoutFrame_storeAction');
            },
        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>